import { matterPaths, kRouteSegments } from '@/routing/paths'

export type ChatFeatureRouteSegment = typeof kRouteSegments.agentV2

/**
 * Builds the path for navigating to a specific conversation.
 * Uses the matter-first URL structure: /dashboard/m/:matterId/chat/agent/:chatId
 *
 * @param matterId - The matter context for the URL (required)
 * @param conversationId - The unique ID of the conversation to navigate to
 * @returns A string representing the full path to navigate to the conversation
 */
export function buildConversationPath(matterId: string, conversationId: string, feature: ChatFeatureRouteSegment = kRouteSegments.agentV2): string {
  return matterPaths.chat.conversation(matterId, feature, conversationId)
}

/**
 * Builds the path for navigating to the chat feature.
 * Uses the matter-first URL structure: /dashboard/m/:matterId/chat/agent
 *
 * @param matterId - The matter context for the URL (required)
 * @returns A string representing the full path to navigate to the chat
 */
export function buildChatFeaturePath(matterId: string, feature: ChatFeatureRouteSegment = kRouteSegments.agentV2): string {
  return matterPaths.chat.feature(matterId, feature)
}
